import { Box, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { linear_content_style, linear_item, linear_v, } from "../../../libs/linear-layout/LinearLayout";
import { useUniForm } from "../../dao/UniFormDAO";
import { useUniFunc } from "../../dao/UniFuncDAO";
import { useUniOptionList } from "../../dao/UniOptionDAO";
import { UniQuestion } from "../../dao/UniQuestion";
import { useUniQuestionList } from "../../dao/UniQuestionDAO";
import { R } from "../../R";
import DgvUniQuestion from "./DgvUniQuestion";
import DgvUniOption from "./DgvUniOption";

type Props = {};

const FrmUniFormDefinition = (props: Props) => {
  const [searchParams] = useSearchParams(); // UrlQueryParams
  const form_guid = searchParams.get("form") ?? "";

  const focus_question = searchParams.get("focus_question");

  //---------------------------------------------------------
  const { _UniForm } = useUniForm(form_guid);

  const { _UniFunc } = useUniFunc(_UniForm?.func_guid ?? "");

  const { _UniQuestionList, set_UniQuestionList, refresh_UniQuestionList } =
    useUniQuestionList(_UniForm?.guid ?? "");

  const [CurrUniQuestion, setCurrUniQuestion] = useState<UniQuestion | null>(
    null
  );

  const { _UniOptionList, set_UniOptionList, refresh_UniOptionList } =
    useUniOptionList(CurrUniQuestion?.guid ?? "");
  const [InitFocusQuestionGuid, set_InitFocusQuestionGuid] = useState<
    string | undefined
  >(undefined);
  useEffect(() => {
    async function refresh_UniForm() {
      if (_UniQuestionList == null) {
        return;
      }

      if (focus_question == null) {
        return; // 不做 focus
      }

      const find = _UniQuestionList.find((x) => x.guid === focus_question);

      if (find != null) {
        setCurrUniQuestion(find);
        set_InitFocusQuestionGuid(find.guid);
      }
    }

    refresh_UniForm();
  }, [JSON.stringify(_UniQuestionList, null, 4)]);

  if (_UniQuestionList === undefined) {
    //2024-03-18  YAO 暫時拔除Loading...以解決翻譯問題
    return <div></div>;
  }

  return (
    <Box style={linear_content_style} bgcolor={R.color.paper} sx={{ p: 2 }}>
      <Grid {...linear_v}>
        <Grid {...linear_item} flex={3} sx={{ px: 1 }}>

          <DgvUniQuestion
            onClickRefresh={async () => {
              await refresh_UniQuestionList();
            }
            }
            InitFocusQuestionGuid={InitFocusQuestionGuid} // 預設 Focus
            CurrUniFunc={_UniFunc}
            CurrUniForm={_UniForm}
            _UniQuestionList={_UniQuestionList ?? []}
            set_UniQuestionList={set_UniQuestionList}
            refreshUniQuestionList={refresh_UniQuestionList}
            OnRowClick={function (sel_data: UniQuestion): void {
              setCurrUniQuestion(sel_data);
            }}
          />
        </Grid>
        <Grid {...linear_item} flex={3} sx={{ px: 1 }}>
          {
            <DgvUniOption
              CurrUniQuestion={CurrUniQuestion}
              _UniOptionList={_UniOptionList}
              set_UniOptionList={set_UniOptionList}
              refresh_UniOptionList={refresh_UniOptionList}
            />
          }
        </Grid>
      </Grid>
    </Box>
  );
};

export default FrmUniFormDefinition;
